export const styles = {
  container: {
    width: '100%',
    minHeight: '60px',
    display: 'grid',
    gridTemplateColumns: '20% 24% 40% 16%;',
  },

  clientCampaignCardWrapper: {
    padding: '16px',
    marginBottom: '16px',
    background: '#ffffff',
    borderRadius: '8px',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px;',
    transform: 'scale(1)',
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
      transform: 'scale(1.02)',
    },
    '@media (max-width: 768px)': {
      marginBottom: '32px',
    },
  },
  disableCardClick: {
    cursor: 'default',
  },
  cardSection: {
    display: 'flex',
    alignItems: 'center',
    borderRight: '1px solid #E2E2FC',
    wordWrap: 'break-word',
    '&:last-of-type': {
      borderRight: '0px',
      borderBottom: '0px',
    },
    '@media (max-width: 768px)': {
      borderBottom: '1px solid #E2E2FC',
      borderRight: 'unset',
      '&:first-of-type': {
        borderBottom: '0px',
      },
    },
  },
  cardSectionEDDM: {
    display: 'flex',
    alignItems: 'center',
  },
  nonRightBorder: {
    borderRight: '0px',
  },
  campaignDataSection: {
    height: '100%',
    display: 'flex',
    padding: '0 16px',
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      width: '100%',
      padding: '10px 0',
    },
  },
  metricsSection: {
    height: '100%',
    flex: 1,
    display: 'grid',
    padding: '0 16px',
    gridTemplateColumns: '20% 20% 20% 20% 20%',
    '@media (max-width: 768px)': {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      flexWrap: 'wrap',
      padding: '16px 0 0',
      gap: '12.5%',
    },
  },
  dataSectionSelfServe: {
    justifyContent: 'start',
  },
  campaignName: {
    paddingRight: '20px',
    width: '100%',
    '@media (max-width: 768px)': {
      fontWeight: 'bold',
    },
  },
  campaignDataFirst: {
    // flex: '40%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'row-reverse',
      justifyContent: 'left',
      gap: '10px',
      width: '100%',
    },
  },
  campaignDataSecond: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: '180px',
    '@media (max-width: 1660px)': {
      paddingLeft: '20px',
    },
    '@media (max-width: 768px)': {
      flexDirection: 'row',
      gap: '20px',
      padding: '16px 0 6px',
      width: '100%',
      paddingLeft: '0px',
    },
  },
  spaceAround: {
    justifyContent: 'space-around',
    '@media (max-width: 768px)': {
      justifyContent: 'normal',
    },
  },
  date: {
    display: 'flex',
    justifyContent: 'end',
    gap: '8px',
    '@media (max-width: 1660px)': {
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  dataLabel: {
    color: '#4F5B94',
  },
  status: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 15px;',
    borderRadius: '8px',
    backgroundColor: '#F9F9FF',
    minWidth: '100px',
  },
  campaignType: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  campaignTypeLabel: {
    marginLeft: '5px',
  },

  metric: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    '@media (max-width: 1660px)': {
      justifyContent: 'space-around',
    },
    '@media (max-width: 768px)': {
      flex: '1 1 calc(30% - 12.5%)',
      maxWidth: '25%',
      marginBottom: '16px',
      gap: 6,
    },
  },
  progressWrapper: {
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-around',
    alignItems: 'normal',
    '@media (max-width: 768px)': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '16px 0 0',
    },
  },

  columnHeader: {
    color: '#B8B8B8',
  },
  progressBar: {
    display: 'flex',
    fontSize: '12px',
  },
  resumeCampaignContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    paddingLeft: '30px',
    '@media (max-width: 768px)': {
      paddingLeft: '0',
      marginTop: 6,
    },
  },
  reviewMessage: {
    paddingRight: '0px',
  },
  moreIcon: {
    marginLeft: '20px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  progressLabel: {
    '@media (max-width: 768px)': {
      width: '65%',
    },
  },
  deleteButton: {
    display: 'flex',
    alignItems: 'center',
  },
}
